var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0V6.25H19L12.6667 0ZM11.0833 6.25V0H2.375C1.06331 0 0 1.04932 0 2.34375V22.6562C0 23.9502 1.06331 25 2.375 25H16.625C17.9367 25 19 23.9507 19 22.6562V7.8125H12.7112C11.7909 7.8125 11.0833 7.11426 11.0833 6.25ZM11.0833 18.75C11.0833 19.6128 10.3743 20.3125 9.5 20.3125H4.75C3.8757 20.3125 3.16667 19.6128 3.16667 18.75V14.0625C3.16667 13.1997 3.8757 12.5 4.75 12.5H9.5C10.3743 12.5 11.0833 13.1997 11.0833 14.0625V18.75ZM15.8333 13.9111V18.9062C15.8333 19.52 15.1495 19.894 14.6221 19.5688L12.6667 18.3594V14.4531L14.6221 13.2471C15.1505 12.9199 15.8333 13.2959 15.8333 13.9111Z",
    fill: "#13A859"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_2545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e99e646d3c43e5fe9025b102c6bea67f.svg";
export { ForwardRef as ReactComponent };